import React, {useEffect, useState} from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Box from "@mui/material/Box";
import {AsyncWrapperStyles} from "./AsyncWrapper.styles";
import axios from "axios";
import ErrorLog from "../ErrorLog/ErrorLog";

const AsyncWrapper = ({label, children, endPoint, dataKey = null, dataType = null, callback}) => {
  const[errorInfo, setErrorInfo] = useState();
  const[status, setStatus] = useState();

  // User environment.
  const env = process.env.NODE_ENV;

  useEffect(()=> {
    // Creating a controller
    let controller = new AbortController();
    let isMounted = true;
    // Setting loading state.
    setStatus('loading');

    axios.get(endPoint, {headers: {'ngrok-skip-browser-warning': true }, signal: controller.signal})
      .then(async response => {
        const data = await response.data;
        if(isMounted && response.statusText === "OK") {
          /* Data type validation.
          if((dataKey !== null && dataType !== null)  && typeof data[dataKey] !== dataType) {
            let errorInfo = {type: 'Data Error', wrongType: typeof data[dataKey]}
            return Promise.reject(errorInfo);
          }*/
          // If no errors, return hook with data.
          callback(dataKey !== null ? data[dataKey] : data);
          setStatus('success');
        }
      })
      .catch( error => {
        if(isMounted) {
          setStatus('error');
          setErrorInfo({type: 'Fetch Error', ...error});
        }
      })

    // Cleaning component.
    return function cleanup() {
      controller?.abort("Unmounted component");
      isMounted = false
    }

  },[callback, dataKey, dataType, endPoint]);

  return (
    <Box sx={AsyncWrapperStyles}>
      <div className='async-wrapper'>
        {
          status === 'loading' &&
            <div className='async-wrapper__loading'>
              <p className='loading__message'>Fetching <span className='loading__message-label'>{ label ?? 'API' }</span> data</p>
              <CircularProgress className={'loading__animation'}/>
            </div>
        }
        {
          // On successfully data eval render child component.
          status === 'success' && children
        }
        {
          (status === 'error' && errorInfo) && <ErrorLog errorInfo={errorInfo} component={label} environment={env}/>
        }
      </div>
    </Box>
  )
}

export default React.memo(AsyncWrapper);
